var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpresa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.999,
    height: 49.999,
    viewBox: "0 0 34.999 49.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "empresa",
    d: "M-1648.273-3397H-1660a1,1,0,0,1-1-1v-48a1,1,0,0,1,1-1h33a1,1,0,0,1,1,1v48a1,1,0,0,1-1,1h-11.727v-9.7a.3.3,0,0,0-.3-.3h-8.945a.3.3,0,0,0-.3.3v9.7Zm13.027-21.667a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.763a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Zm-11.137,0a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.764a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Zm-11.136,0a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.764a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Zm22.272-11.666a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.763a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Zm-11.137,0a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.764a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Zm-11.136,0a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.764a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Zm22.272-11.667a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.763a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Zm-11.137,0a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.764a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Zm-11.136,0a.3.3,0,0,0-.3.3v6.066a.3.3,0,0,0,.3.3h5.764a.3.3,0,0,0,.3-.3v-6.066a.3.3,0,0,0-.3-.3Z",
    transform: "translate(1661 3447)",
    fill: "#004687"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpresa);
export default __webpack_public_path__ + "static/media/empresa.e400acb018de695d267efc68cc25fad3.svg";
export { ForwardRef as ReactComponent };